import { render, staticRenderFns } from "./DataLogDetails.vue?vue&type=template&id=5aaeccd9"
import script from "./DataLogDetails.vue?vue&type=script&lang=js"
export * from "./DataLogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports